import * as swcHelpers from '@swc/helpers';

const convertCmsRxEntries = (entryTypes)=>{
    if (!entryTypes) return;
    const ConversionMap = {
        'existing-customer': 'ExistingCustomer',
        email: 'EmailPrescription',
        'file-upload': 'PrescriptionFile',
        'form-entry': 'NewPrescription',
        'book-appointment': 'book-appointment'
    };
    return entryTypes.map((item)=>swcHelpers.objectSpread({}, item, {
            key: ConversionMap[item.key]
        })
    );
};

export { convertCmsRxEntries };
//# sourceMappingURL=convert-cms-rx-entries.js.map
